// extracted by mini-css-extract-plugin
module.exports = {"alwaysVisible":"InsuranceReview-module__alwaysVisible___3Ds5O","separator":"InsuranceReview-module__separator___3Yx-Y","agreement":"InsuranceReview-module__agreement___709Fs"};